import { createApiRequest } from "../common";
import { ListUserOrganizationsRequestContent as ListUserOrganizationsRequestContentv2, ListUserOrganizationsResponseContent as ListUserOrganizationsResponseContentv2 } from '@equaliq/api-model-v2';
import { ListUserOrganizationsRequestContent, ListUserOrganizationsResponseContent } from "@equaliq/api-model";

export const getUserOrganizationsApi = async (request?: ListUserOrganizationsRequestContent): Promise<ListUserOrganizationsResponseContent> => {
  const apiRequest = createApiRequest<ListUserOrganizationsResponseContent>('post', '/orgs/listUserOrganizations');
  return apiRequest(request || {});
};

export const getUserOrganizationsApiv2 = async (request?: ListUserOrganizationsRequestContentv2): Promise<ListUserOrganizationsResponseContentv2> => {
  const apiRequest = createApiRequest<ListUserOrganizationsResponseContentv2>('post', '/orgs/listUserOrganizations');
  return apiRequest(request || {});
};